export default "__VITE_ASSET__YQ8qN2FW__"